import { evalAuthHeaders, getEvalBase } from '../../evalApiBase'
import {
  buildTagsListQuery,
  Tag,
  TagCreateInput,
  TagFilters,
  TagListResponse,
  TagUpdateInput,
} from './tagsAdminModel'

async function readErrorDetail(res: Response): Promise<string | null> {
  try {
    const body = await res.json()
    if (body && typeof body.detail === 'string') {
      return body.detail
    }
  } catch {
    // fall through
  }
  return null
}

export async function listTags(filters: TagFilters): Promise<TagListResponse> {
  const query = buildTagsListQuery(filters)
  const res = await fetch(`${getEvalBase()}/v1/tags?${query}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Tags list failed: ${res.status}`)
  }
  return res.json()
}

export async function createTag(input: TagCreateInput): Promise<Tag> {
  const res = await fetch(`${getEvalBase()}/v1/tags`, {
    method: 'POST',
    headers: { ...evalAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
  if (!res.ok) {
    // Surface the backend detail — an active-name collision returns 409 with an
    // actionable message.
    const detail = await readErrorDetail(res)
    throw new Error(detail || `Tag create failed: ${res.status}`)
  }
  return res.json()
}

export async function updateTag(input: TagUpdateInput): Promise<Tag> {
  const { tag_id, ...payload } = input
  const res = await fetch(`${getEvalBase()}/v1/tags/${tag_id}`, {
    method: 'PATCH',
    headers: { ...evalAuthHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) {
    // A rename into an existing active name returns 409 with an actionable message.
    const detail = await readErrorDetail(res)
    throw new Error(detail || `Tag update failed: ${res.status}`)
  }
  return res.json()
}

export async function deleteTag(tagId: string): Promise<void> {
  const res = await fetch(`${getEvalBase()}/v1/tags/${tagId}`, {
    method: 'DELETE',
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    const detail = await readErrorDetail(res)
    throw new Error(detail || `Tag delete failed: ${res.status}`)
  }
}
